import { Component } from '@theme/component';

class GunerHero extends Component {
  #controller;
  #request = 0;
  #tabs = [];
  #panels = [];

  connectedCallback() { super.connectedCallback(); this.#bind(); }
  updatedCallback() { super.updatedCallback(); this.#bind(); }
  disconnectedCallback() { this.#controller?.abort(); this.#request++; super.disconnectedCallback(); }

  #bind() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.#request++;
    const options = { signal: this.#controller.signal };
    this.#tabs = [...this.querySelectorAll('[role="tab"]')];
    this.#panels = this.#tabs.map(tab => this.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls'))));
    this.#tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.#select(tab), options);
      tab.addEventListener('pointerenter', () => this.#prepare(this.#panels[index]).catch(() => {}), options);
      tab.addEventListener('focus', () => this.#prepare(this.#panels[index]).catch(() => {}), options);
      tab.addEventListener('keydown', event => {
        let next;
        if ((event.key === 'ArrowDown' || event.key === 'ArrowRight')) next = (index + 1) % this.#tabs.length;
        else if ((event.key === 'ArrowUp' || event.key === 'ArrowLeft')) next = (index + this.#tabs.length - 1) % this.#tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.#tabs.length - 1;
        else return;
        event.preventDefault();
        this.#tabs.forEach((item, i) => item.tabIndex = i === next ? 0 : -1);
        this.#tabs[next].focus();
      }, options);
    });
    this.addEventListener('shopify:block:select', event => {
      const panel = event.target.closest('.gh-panel');
      const index = this.#panels.indexOf(panel);
      if (index >= 0) this.#select(this.#tabs[index]);
    }, options);
  }

  async #prepare(panel) {
    const image = panel?.querySelector('.gh-image');
    if (!image) throw new Error('Missing hero image');
    if (!image.getAttribute('src')) {
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      image.src = image.dataset.src;
    }
    await image.decode();
  }

  async #select(tab) {
    const sequence = ++this.#request;
    const index = this.#tabs.indexOf(tab);
    const status = this.querySelector('.gh-status');
    status.textContent = '';
    tab.setAttribute('aria-busy', 'true');
    try {
      await this.#prepare(this.#panels[index]);
      if (sequence !== this.#request || !this.isConnected) return;
      this.#tabs.forEach((item, i) => {
        item.setAttribute('aria-selected', String(i === index));
        item.tabIndex = i === index ? 0 : -1;
        this.#panels[i].hidden = i !== index;
      });
    } catch {
      if (sequence === this.#request && this.isConnected) status.textContent = this.dataset.loadError;
    } finally { tab.removeAttribute('aria-busy'); }
  }
}

if (!customElements.get('guner-hero')) customElements.define('guner-hero', GunerHero);
